import * as React from 'react';
import * as logrocket from 'logrocket';
import log from '../whisper';
export var logRocketTrack = function (event) {
    log.debug({ message: ['Tracking event:', event] });
    logrocket.track(event);
};
var defaultLogger = {
    track: logRocketTrack,
};
export var useLogRocketTracking = function (logger, event) {
    if (logger === void 0) { logger = defaultLogger; }
    React.useEffect(function () { return logger.track(event); }, [event]);
};
//# sourceMappingURL=log-rocket.js.map